import {
  model,
  Model,
  modelAction,
  prop,
  Frozen,
  rootRef,
  modelFlow,
  _async,
  getRoot,
  _await,
  findParent,
  getSnapshot,
} from "mobx-keystone";
import { computed, observable } from "mobx";
import { Cubby } from "./Cubby";

@model("exrails/Task")
export class Task extends Model({
  _version: prop(0),
  createdAtTimestamp: prop<number>(),
  uuid: prop<string>(),
  kind: prop<string>(),
  humanReadableKind: prop<string>(),
  lifecycleStatus: prop<string>(),
  humanReadableLifecycleStatus: prop<string>(),
  frontEndSawTerminalLifecycleStatus: prop<boolean>(false),
}) {
  getRefId() {
    // when `getId` is not specified in the custom reference it will use this as id
    return this.uuid;
  }

  @modelAction
  setFrontEndSawTerminalLifecycleStatus(value: boolean) {
    this.frontEndSawTerminalLifecycleStatus = value;
  }

  @computed
  get cubby() {
    return findParent<Cubby>(this, (parentNode) => parentNode instanceof Cubby);
  }

  @computed
  get isTerminal() {
    return (
      this.lifecycleStatus === "completed" || this.lifecycleStatus === "errored"
    );
  }

  @modelAction
  maybeSetToFrontendSawTerminalLifecycleStatus() {
    // console.log("maybeSetToFrontendSawTerminalLifecycleStatus");
    // console.log(
    //   "need to set this on rails and then locally after a n second timeout"
    // );
    // console.log(getSnapshot(this));

    if (!this.isTerminal) {
      return;
    }

    const data = {
      taskUuid: this.uuid,
    };

    this.cubby.cubbyFastUpdate("front_end_saw_terminal_lifecycle_status", data);

    // Add a timeout to set the frontEndSawTerminalLifecycleStatus after 3.5 seconds
    setTimeout(() => {
      this.setFrontEndSawTerminalLifecycleStatus(true);
    }, 4000); // 3500 milliseconds = 3.5 seconds
  }
}
